<nav class="navbar navbar-expand-lg navbar-light bg-light" [ngClass]="{ 'home-navbar': isHomePage }">
    <div class="container-fluid custom-width">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/jrt-logo.png" alt="Logo" height="30">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
            <ul class="navbar-nav mx-auto">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/aboutus">About Us</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/products">Products</a>
                </li>
            </ul>
            <ul class="navbar-nav justy-content-end">
                <li class="nav-item">
                    <a class="nav-link nav-contact" routerLink="/contactus">Contact Us</a>
                </li>
            </ul>
        </div>
    </div>
</nav>